<div class="container-fluid p-0">

  <div class="row">

    <div class="col-md-6 px-0 pe-3">
      <div class="card h-100">
        <div class="card-header bg-light justify-content-between">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">From Regulation</h5>
            <span class="badge bg-primary ms-2">{{ fromRegulation.length }}</span>
          </div>
          <div class="mt-2">
            <div class="row justify-content-around">
              <div class="col-md-5">
                <div class="input-group">
                  <select class="form-select form-select-sm"
                    (change)="filterByLaw($any($event.target).value ? +$any($event.target).value : null)">
                    <option value="">All Laws</option>
                    @for (law of lawsOptions; track law) {
                      <option [value]="law.key">{{ law.value }}</option>
                    }
                  </select>
                </div>
              </div>
              <div class="col-md-5">
                <div class="input-group">
                  <select class="form-select form-select-sm"
                    (change)="filterByCategory($any($event.target).value ? +$any($event.target).value : null)">
                    <option value="">All Categories</option>
                    @for (category of categoryOptions; track category) {
                      <option [value]="category.key">{{ category.value }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body" style="max-height: 600px; overflow-y: auto;">
          <div class="list-group">
            @for (regulation of fromRegulation; track regulation) {
              <div class="list-group-item list-group-item-action mb-2"
                [ngClass]="{'opacity-50': isTemporarilySelected(regulation) || isInChecklist(regulation)}">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="mb-1">{{ regulation.title}}</h6>
                    <p class="mb-1 text-muted small">{{ (regulation.details)?.substring(0, 100) }}{{
                    (regulation.details)?.length > 100 ? '...' : '' }}</p>
                    <div class="mt-2">
                      @for (category of regulation.categories; track category) {
                        <span class="badge bg-primary me-1 mb-1">
                          {{ category.name }}
                        </span>
                      }
                    </div>
                    @if (isInChecklist(regulation)) {
                      <div class="mt-2">
                        <span class="badge bg-secondary">Already in checklist</span>
                      </div>
                    }
                  </div>
                  <div class="ms-2 d-flex flex-column">
                    <button class="btn btn-light btn-sm mb-2" (click)="openDetails(regulation, detailModal)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button class="btn btn-sm" [disabled]="isTemporarilySelected(regulation) || isInChecklist(regulation)"
                      [ngClass]="isTemporarilySelected(regulation) ? 'btn-secondary' : 'btn-success'"
                      (click)="toggleSelection(regulation)">
                      {{ isTemporarilySelected(regulation) ? '-' : '+' }}
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (fromRegulation.length === 0) {
              <div class="text-center p-3">
                <p class="text-muted">No regulations available</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6 px-0">
      <div class="card h-100">
        <div class="card-header bg-light justify-content-between">
          <div class="d-flex justify-content-between align-items-center w-auto">
            <h5 class="mb-0">To Checklist</h5>
            <span class="badge bg-success ms-2">{{ toChecklist.length + toChecklistTemp.length }}</span>
          </div>
        </div>
        <div class="card-body" style="max-height: 600px; overflow-y: auto;">
          <div class="list-group">
            @for (regulation of toChecklist; track regulation) {
              <div class="list-group-item list-group-item-action mb-2">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="mb-1">{{ regulation.title}}</h6>
                    <p class="mb-1 text-muted small">{{ (regulation.details)?.substring(0, 100) }}{{
                    (regulation.details)?.length > 100 ? '...' : '' }}</p>
                    <div class="mt-2">
                      @for (category of regulation.categories; track category) {
                        <span class="badge bg-primary me-1 mb-1">
                          {{ category.name }}
                        </span>
                      }
                    </div>
                  </div>
                  <div class="ms-2 d-flex flex-column">
                    <button class="btn btn-light btn-sm mb-2" (click)="openDetails(regulation, detailModal)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button class="btn btn-danger btn-sm" (click)="removeFromChecklist(regulation)">
                      -
                    </button>
                  </div>
                </div>
              </div>
            }

            @for (regulation of toChecklistTemp; track regulation) {
              <div class="list-group-item list-group-item-action mb-2">
                <div class="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 class="mb-1">{{ regulation.title}}</h6>
                    <p class="mb-1 text-muted small">{{ (regulation.details)?.substring(0, 100) }}{{
                    (regulation.details)?.length > 100 ? '...' : '' }}</p>
                    <div class="mt-2">
                      @for (category of regulation.categoryList; track category) {
                        <span class="badge bg-primary me-1 mb-1">
                          {{ category.name }}
                        </span>
                      }
                    </div>
                    <div class="mt-2">
                      <span class="badge bg-warning">Pending save</span>
                    </div>
                  </div>
                  <div class="ms-2 d-flex flex-column">
                    <button class="btn btn-light  btn-sm mb-2" (click)="openDetails(regulation, detailModal)">
                      <i class="fa fa-eye"></i>
                    </button>
                    <button class="btn btn-danger btn-sm" (click)="toggleSelection(regulation)">
                      -
                    </button>
                  </div>
                </div>
              </div>
            }

            @if (toChecklist.length === 0 && toChecklistTemp.length === 0) {
              <div class="text-center p-3">
                <p class="text-muted">No regulations in checklist</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-6 col-sm-12 mt-3 ps-0">
      <regulations-changes-logs [auditLogs]="auditLogs" />
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12 d-flex justify-content-center mt-3">
      <button class="btn btn-success px-4 py-2" [disabled]="!hasChanges && toChecklistTemp.length === 0 || isSaving"
        (click)="saveChecklist()">
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </div>
</div>

<!-- Detail Modal -->
<ng-template #detailModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Regulation Details</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    @if (detailRegulation) {
      <div>
        <h5>{{ detailRegulation.title }}</h5>
        <div class="mb-3">
          @for (category of detailRegulation.categoryList; track category) {
            <span class="badge bg-primary me-1">
              {{ category.name }}
            </span>
          }
        </div>
        <hr>
          <p class="mb-4" style="white-space: pre-line;">{{ detailRegulation.details }}</p>
        </div>
      }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="modal.close()">Close</button>
    </div>
  </ng-template>